export default {
  title: "Тарифтер",
  tariff: "Тариф",
  yourTariff: "Сіздің тарифіңіз",
  lessTariffModal: {
    title: "Сыйлық карталарын шығару сіздің тарифіңізде қолжетімсіз",
    subtitle:
      "Сыйлық карталарын шығару үшін «Промо» немесе «Про+» тарифіне өтіңіз",
  },
  lite_p: {
    title: "Лайт",
    list: [
      '<span itemprop="name">1 ұйымды тіркеу',
      '<span itemprop="name">5 сауда нүктесін құру',
      '<span itemprop="name">Жеңілдетілген статистика',
      '<span itemprop="name">RC KASSA-ға қолжетімділік',
      '<span itemprop="name">Электронды құжат айналымы',
      '<span itemprop="name">Айына 2 рет есеп айырысу',
      '<span itemprop="name">Сұрақтар мен жауаптар бөлімі',
    ],
  },

  faq: [
    {
      title: "Клиентті цифрландыру қалай жүреді?",
      text:
        "<p>Клиентті цифрландыру үшін оған промокод беруіңіз керек. Ол сілтеме, QR-код немесе цифрландыру коды түрінде болуы мүмкін. Осы кодты пайдаланып, клиент rcpay.ru клиенттік сервисінде тіркелуі қажет.</p>" +
        "<br>" +
        "<p>Назар аударыңыз: QR-кодты оқу үшін клиентке камерасы бар құрылғы немесе QR-кодтарды оқуға арналған арнайы қосымша қажет.</p>",
    },
    {
      title: "«Белсенді» клиент деген не?",
      text:
        "<p>Бұл сіз цифрландырған және RC Group экожүйесіндегі онлайн немесе офлайн мекемеде сатып алу жасаған клиент. Онлайн-сатып алуларға RC Market-тен шопинг, сертификаттар сатып алу, Яндекс сервистерін іске қосу, пайдаланушылық тариф сатып алу кіреді. Офлайн операциялар — бұл қаладағы мекемелерде RC.Kassa қолдану арқылы жасалған сатып алулар.</p>" +
        "<br>" +
        "<p>«Корпоративтік» тарифін сатып алу кезінде әр серіктес тарифті ұзартуға «50% жеңілдік» акциясына қатысады. Акцияның басты шарты — 500 «белсенді» клиентті цифрландыру.</p>",
    },
    {
      title: "Егер тарифті ұзартпасам не болады?",
      text: "<p>Бұл жағдайда кабинет функционалы «Базалық» тариф деңгейіне дейін қысқарады. Сізге «Клиенттер тізімі» бөлімі қолжетімді болады, бірақ Wallet карталарын шығару, Push-хабарламалар жіберу және «Қолма-қолсыз шайпұл» сервисіне қол жеткізу мүмкіндігіңіз болмайды.</p>",
    },
    {
      title: "Көбірек клиентті қалай тартуға және цифрландыруға болады?",
      text: "<p>Цифрландыруға арналған сілтемені әлеуметтік желілерге орналастыру үшін «Бөлісу» функциясын пайдаланыңыз. Сондай-ақ, мекемеңізде тейбл-тенттерді, жапсырмаларды, парақшаларды, воблерлерді орналастырыңыз.</p>",
    },
    {
      title: "Менің сұрағым жоқ, жауапты қалай алуға болады?",
      text:
        "<p>Техқолдауға сұрақ қойыңыз. Ол үшін төменгі оң жақтағы RC Group белгішесін басып, «Telegram»-ды таңдаңыз да, мәселені сипаттап жазыңыз, қажет болса скриншоттар тіркеңіз. Маманымыз сізбен міндетті түрде байланысып, мәселені қысқа мерзімде шешеді.</p>" +
        "<br>" +
        "<p>Сондай-ақ хатты мына поштаға жіберуге болады: <a href='mailto:hello@rc.company'>hello@rc.company</a> </br>" +
        "<br>" +
        "Немесе телефон арқылы қоңырау шалыңыз: <b>8 (800) 500-57-62.</b></p>",
    },
  ],
  digitizedClientsCounter: "Цифрланған клиенттердің есептегіші",
  activeClientsDigitized: "Цифрланған белсенді клиенттер",
  reg500AndMoreClients:
    "Лоялдылық бағдарламасына <b>500 және одан да көп белсенді клиентті</b> тіркеп, тарифті ұзартуға 50% жеңілдік алыңыз",
  choosePointToGenerateQr:
    "RC PAY-ге жаңа клиенттерді тіркеу үшін сілтеме мен QR-кодты генерациялау үшін сауда нүктесін таңдаңыз.",
  afterBuyTariffYouCanGenerate:
    "Тарифті сатып алғаннан кейін RC PAY-ге жаңа клиенттерді тіркеу үшін сілтеме мен QR-кодты генерациялау мүмкіндігі ашылады.",
  useLinkAndQrForRegNewClients:
    "RC PAY-ге жаңа клиенттерді тіркеу үшін сілтеме мен QR-кодты пайдаланыңыз.",
  shareLink: "Сілтемемен бөлісу",
  anyOtherQuestions: "Басқа сұрақтарыңыз бар ма?",
  tariffSuccessPayed: "«{tariff}» тарифі сәтті төленді",
  tariffPayFromMainEntity:
    "Тарифті төлеу негізгі заңды тұлғаның<br />нақты балансынан жүргізіледі.",
  period: "Мерзім",
  cost: "Құны",
  discount: "Жеңілдік {discount}%",
  totalToPay: "Жалпы төлем",
  lite: "Лайт",
  promo: "Промо",
  plusPro: "Про+",
  basic: "Базалық",
  corporate: "Корпоративтік",
  popular: "Танымал",
  advanced: "Кеңейтілген",
  includesToTariff: "Тарифке кіреді",
  allInLitePlus: "Барлығы «Лайт» тарифінен, қосымша",
  allInPromoPlus: "Барлығы «Промо» тарифінен",
  allInBasicPlus: "Барлығы «Базалық» тарифінен, қосымша",
  forFree: "Тегін",
  buyTariff: "Тариф сатып алу",
  tradingPoints: "сауда нүктесі",
  products: "Тауарлар",
  unlimitProducts: "Шексіз тауарлар",
  uCanAddProductsToEMenu:
    "Онлайн-каталогқа {productsCount} тауар қосып, олар бойынша RC PAY арқылы онлайн-тапсырыс ала аласыз",
  canAddUnlimitProductsToEMenu:
    "Онлайн-каталогқа шексіз тауар қосып, олар бойынша RC PAY арқылы онлайн-тапсырыс ала аласыз",
  twoTgMailingPerWeek: "Аптасына 2 Telegram тарату",
  oneTgMailingPerDay: "Күніне 1 Telegram тарату",
  canCreateAndSend2NotifyPerWeek:
    "Аптасына әр сауда нүктесінің клиенттеріне Telegram-бот арқылы 2 хабарлама жіберуге болады",
  canCreateAndSend1NotifyPerDay:
    "Күніне әр сауда нүктесінің клиенттеріне Telegram-бот арқылы 1 хабарлама жіберуге болады",
  basicAnalytics: "Базалық аналитика",
  analyticsHint: "Сауда нүктелері мен заңды тұлғалар бойынша аналитика",
  accrualDeducationPoints: "RC KASSA-да ұпайларды есептеу және шығару",
  enablingPaymentMethods: "Төлем тәсілдерін қосу",
  postingYourShopsInRC: "RC PAY-де мекемелеріңізді жариялау",
  postingYourShopsHint:
    "RC PAY-де орналастыру ережелеріне сәйкес болған жағдайда<br><br><a target='_blank' href='/docs/Правила размещения.pdf'>RC PAY-де орналастыру ережелерін қараңыз</a>",
  gettingOnlineOrders: "Тауарлар/қызметтер бойынша онлайн-тапсырыстар алу",
  orderPromotionYourShops: "Сауда нүктелерін жылжытуға тапсырыс беру",
  advancedAnalytics: "Кеңейтілген аналитика",
  advancedAnalyticsHint:
    "Сауда нүктелері, заңды тұлғалар, кассирлер, клиенттер бойынша аналитика және RFM-талдау",
  evaluationCashierWork: "Кассирлердің жұмысын бағалау",
  digitizingClients: "Клиенттерді цифрландыру",
  accessToClientsList: "Клиенттер тізіміне қолжетімділік",
  infoAboutAllClients:
    "Сіздің мекемеңізге келген барлық клиенттер туралы ақпарат, олардың контактілері, чектер мен статистика",
  pushNotifyToClientWalletCard:
    "Wallet картасына клиенттерге Push-хабарлама жіберу",
  scoringPointsByGroups: "Клиенттер топтары бойынша ұпай есептеу",
  uCanSetDifferentPercentAward:
    "Клиенттердің сатып алу сомасына байланысты әртүрлі % сыйақы орнатуға болады",
  distributionRCCard: "RC карталарын тарату",
  designWalletCard: "Wallet картасының дизайны",
  issuingGiftCard: "Сыйлық карталарын шығару",
  priorityMaintenance: "Артықшылықты қызмет көрсету",
  monetizationUpTo30Percent:
    "Клиенттің есептелген сыйақысынан 30%-ға дейін монетизация",
  monetizationHint:
    "Егер сіздің ұйымыңыздың қызмет түріне сәйкес адалдық бағдарламасынан кіріс алу мүмкіндігі болса",
  adding1Entity: "1 заңды тұлға қосу",
  accessToOperationsHistory: "Операциялар тарихына қолжетімділік",
  basicCabinetFunctional: "Кабинеттің базалық функционалы",
  discountOnTariffRenewal: "Тарифті ұзартуға 50% жеңілдік",
  discountOnTariffRenewalHint:
    "50% жеңілдік соңғы тариф сатып алынғаннан кейін 500 және одан да көп белсенді клиент цифрландырылса беріледі<br><br><a href='#clients-counter'>Клиенттер есептегішін қараңыз</a>",
  autoConnectIfFreeTariff:
    "Егер ақылы тариф сатып алынбаса, автоматты түрде қосылады.",
  tariffBuyingWillAvailableFromDate:
    "Тарифті сатып алу {date} бастап қолжетімді болады",
  entityOnModeration: "Заңды тұлға модерацияда",
  tariffBuyingWillAvailableAfterModeration:
    "Тарифті сатып алу заңды тұлға модерациядан өткеннен кейін қолжетімді болады.",
  notEnoughMoney: "Қаражат жеткіліксіз",
  tariffPayingFromFactBalance:
    "Тарифті төлеу негізгі заңды тұлғаның нақты балансынан жүргізіледі.",
  forBuyingTariffNeedReplenish:
    "«{tariff}» тарифін сатып алу үшін {entity} балансын кемінде {sum} ₽ сомасына толтыру қажет",
  replenishBalance: "Балансты толықтыру",
  canCreate: "Құруға болады",
  forTransitionToTariffConnectWithUs:
    "Ақылы тарифке өту үшін техникалық қолдауға хабарласыңыз <a href='mailto:hello@rc.city;>hello@rc.city</a>",
};
